import { useCrmStore } from "features/Crm/store/useCrmStore";

export const useDeleteColumnModal = () => {
  const setIsDeleteCustomColumnModalOpen = useCrmStore(
    (state) => state.setIsDeleteCustomColumnModalOpen
  );
  const isDeleteCustomColumnModalOpen = useCrmStore(
    (state) => state.isDeleteCustomColumnModalOpen
  );

  const openDeleteCustomColumnModal = () => {
    setIsDeleteCustomColumnModalOpen(true);
  };
  const closeDeleteCustomColumnModal = () => {
    setIsDeleteCustomColumnModalOpen(false);
  };

  return {
    isDeleteCustomColumnModalOpen,
    openDeleteCustomColumnModal,
    closeDeleteCustomColumnModal,
  };
};
